import { Controller } from "@hotwired/stimulus"

// Restores focus and cursor position on the active input after a turbo frame morph.
//
// During a morph render, idiomorph syncs input values from the server response,
// discarding changes the user made while the request was in-flight (e.g. fast
// typing or backspacing). This controller prevents that by patching the incoming
// frame's input value to match what the user currently has typed, before idiomorph
// runs. Focus and cursor position are also restored after the render.
export default class extends Controller {
  connect() {
    this.element.addEventListener("turbo:before-frame-render", this.saveActiveElement)
    this.element.addEventListener("turbo:frame-render", this.restoreFocus)
  }

  disconnect() {
    this.element.removeEventListener("turbo:before-frame-render", this.saveActiveElement)
    this.element.removeEventListener("turbo:frame-render", this.restoreFocus)
  }

  saveActiveElement = (event) => {
    const active = document.activeElement
    if (active && this.element.contains(active)) {
      this.activeName = active.name
      this.selectionStart = active.selectionStart ?? null
      this.selectionEnd = active.selectionEnd ?? null

      // Patch the incoming frame so idiomorph sees the same value the user has
      // typed, preventing it from overwriting the input and causing a visual flash.
      const newFrame = event?.detail?.newFrame
      if (newFrame) {
        const selector = `[name="${CSS.escape(active.name)}"]:not([type="hidden"])`
        const incoming = newFrame.querySelector(selector)
        if (incoming) incoming.setAttribute("value", active.value)
      }
    } else {
      this.activeName = null
    }
  }

  restoreFocus = () => {
    if (!this.activeName) return

    const el = this.element.querySelector(`[name="${this.activeName}"]:not([type="hidden"])`)
    if (!el) return

    el.focus()
    if (this.selectionStart !== null) {
      try { el.setSelectionRange(this.selectionStart, this.selectionEnd) } catch (_e) { /* non-text inputs don't support setSelectionRange */ }
    }
  }
}
